export default __webpack_public_path__ + "static/yongyang1-642467df8ae91bc91c2a0102532621a0.jpg";